module.exports = __webpack_public_path__ + "img/west-map.309b7289.png";